import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import socialHttp from '../../../../../utils/socialHttp';

import classnames from 'classnames';

import Loading from 'Demora/Loading';

import '../../Profile.css';

import './Posts.css';

import errorModal from 'Demora/errorModal';

import resizeImage from 'Demora/resizeImage';

import Textarea from 'react-textarea-autosize';

import ImageUtils from 'Demora/ImageUtils';

import Image from 'Demora/image';

class NewPostBox extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			saving: false,
			uploadImages: [],
			text: this.props.text || '',
			maxrows: this.props.maxRows || 5,
		};
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	componentDidMount() {
		if (this.props.images) {
			this.props.images.map((im) => {
				ImageUtils.read({
					url: Image(im, 0),
				})
					.then((image) => {
						image.getBase64(ImageUtils.MIME_JPEG).then((im1) => {
							let imsInState = this.state.uploadImages;

							imsInState.push({
								imgSrc: im1,
							});

							this.setState({
								uploadImages: imsInState,
							});
						});
					})
					.catch((err) => {
						console.error(err);
					});
			});
		}
	}

	sendPost() {
		let text = this.state.text;

		let g = ['p'];

		if (text || this.state.uploadImages.length > 0) {
			this.setState({
				saving: true,
			});

			let postFormData = new FormData();

			let m = {};

			if (this.state.uploadImages) {
				for (let ii in this.state.uploadImages) {
					if (!m.i) {
						m.i = [];
					}

					m.i.push({ imgSrc: this.state.uploadImages[ii].imgSrc });
				}
			}

			if (text) {
				m.m = text;
			}

			postFormData.append('m', JSON.stringify(m));

			postFormData.append('g', JSON.stringify(g));

			postFormData.append('jid', new Date().getTime());

			let obj = this.props.user.id + '-u';

			if (this.props.obj) {
				obj = this.props.obj;
			}

			socialHttp('post', '/data/feed/' + obj, null, {}, postFormData)
				.then((data) => {
					if (!this.unmounted) {
						this.setState({
							saving: false,
							uploadImages: [],
							text: '',
						});
					}

					if (this.props.onSave) {
						this.props.onSave(Object.keys(data.feed[obj].posts)[0]);
					}
				})
				.catch((error) => {
					if (!this.unmounted) {
						this.setState({
							saving: false,
						});
					}
				});
		}
	}

	sendPicture(e) {
		e.preventDefault();

		var file = e.target.files[0];

		resizeImage(file, 800, 800)
			.then((image) => {
				if (image.imgSrc.length > 1024 * 1024) {
					errorModal(
						'The image is too big, try resizing the image so it is less than 1Mb'
					);
					return;
				}

				this.setState((st) => {
					st.uploadImages = [image];
					return { uploadImages: st.uploadImages };
				});
			})
			.catch((error) => {
				errorModal('There was an error uploading your image');
			});
	}

	deleteImage(i, e) {
		e.preventDefault();

		this.setState((st) => {
			st.uploadImages.splice(i, 1);
			return st;
		});
	}

	render() {
		const { user, obj } = this.props;

		let showPostBox =
			!obj || user.id + '-u' == obj || obj.split('-')[1] == 'g' ? 1 : 0;

		if (!showPostBox) {
			return null;
		}

		return (
			<div className='card well-social-post'>
				{this.state.saving ? (
					<div className='newPost text-center'>
						<Loading />
					</div>
				) : (
					''
				)}
				<ul className='list-inline' id='list_PostActions'>
					<li className='list-inline-item active'>
						<i className='fa fa-edit'></i>
						<span>Post update</span>
					</li>
				</ul>
				<Textarea
					inputRef={(newPost) => (this.newPost = newPost)}
					disabled={this.state.saving}
					className='form-control'
					placeholder='What do you want to post?'
					maxRows={this.state.maxRows}
					value={this.state.text}
					onChange={(event) => {
						this.setState({ text: event.target.value });
					}}
				/>
				{this.state.uploadImages.length > 0 && (
					<ul
						className='list-inline text-center'
						style={{ maxHeight: '250px', borderBottom: 0 }}
					>
						{this.state.uploadImages.map((im, i) => {
							return (
								<li
									className='list-inline-item'
									key={i}
									style={{
										border: '1px solid #eee',
										position: 'relative',
									}}
								>
									<a
										href='#'
										onClick={this.deleteImage.bind(this, i)}
										className='fa fa-times'
										style={{
											position: 'absolute',
											right: '-10px',
											top: '-10px',
											color: '#000',
										}}
									></a>
									<img
										src={im.imgSrc}
										style={{ maxWidth: '250px', maxHeight: '250px' }}
										className='rounded'
									/>
								</li>
							);
						})}
					</ul>
				)}
				<ul className='list-inline post-actions'>
					<li className='list-inline-item'>
						<label className={classnames('uploadButton input-group-text')}>
							<input type='file' onChange={this.sendPicture.bind(this)} />
							<i className='fas fa-camera'></i>
						</label>
					</li>
					<li className='list-inline-item d-none'>
						<a href='#' className='fa fa-user'></a>
					</li>
					<li className='list-inline-item d-none'>
						<a href='#' className='fas fa-map-marker-alt'></a>
					</li>
					<li className='list-inline-item'>&nbsp;</li>
					<li className='list-inline-item float-right'>
						<button
							disabled={this.state.saving}
							onClick={this.sendPost.bind(this)}
							className='btn btn-primary btn-sm'
						>
							Post
						</button>
					</li>
				</ul>
			</div>
		);
	}
}

export default ReduxConnect(NewPostBox, {
	user: 'user',
});
